import { createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '../utils';

export const setOfferLockout = createAsyncThunk(
  'setOfferLockout',
  async (payload: { hash: string; release?: boolean }) => {
    const path = `/api/v1/coupon/${payload.hash}/lockout`;
    const response = await Api.fetch(
      {
        method: payload.release ? 'DELETE' : 'PUT',
        path,
      },
      'trusted',
    );
    return response;
  },
);
